module.exports = __webpack_public_path__ + "img/PrimaryKv_lg_1.ed663a4d.png";